export default __webpack_public_path__ + "static/media/dirideal_preview.8def32d8.png";